module.exports = __webpack_public_path__ + "static/media/civi-logo.800a0bd8.png";